import { render, staticRenderFns } from "./UpdateCardInfo.vue?vue&type=template&id=0bc4ebb2&scoped=true&"
import script from "./UpdateCardInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCardInfo.vue?vue&type=style&index=0&id=0bc4ebb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc4ebb2",
  null
  
)

export default component.exports